<template>
<div class="container">
    <router-view />
</div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  align-items: center;
  display: flex;
  flex-direction: column;
}
</style>
